export default "__VITE_ASSET__BNG42BXF__"